__turbopack_context__.v({
  "comparisonDesktop": "index-module__CkqTEG__comparisonDesktop",
  "comparisonDisclaimer": "index-module__CkqTEG__comparisonDisclaimer",
  "comparisonInner": "index-module__CkqTEG__comparisonInner",
  "comparisonMobile": "index-module__CkqTEG__comparisonMobile",
  "comparisonTitle": "index-module__CkqTEG__comparisonTitle",
  "headerImageCell": "index-module__CkqTEG__headerImageCell",
  "headerImagesRow": "index-module__CkqTEG__headerImagesRow",
  "headerLabel": "index-module__CkqTEG__headerLabel",
  "headerProduct": "index-module__CkqTEG__headerProduct",
  "headerProductPro": "index-module__CkqTEG__headerProductPro",
  "headerThumb": "index-module__CkqTEG__headerThumb",
  "headerTitlesRow": "index-module__CkqTEG__headerTitlesRow",
  "proColumnBg": "index-module__CkqTEG__proColumnBg",
  "root": "index-module__CkqTEG__root",
  "tableWrapper": "index-module__CkqTEG__tableWrapper",
});
